<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="10">
        <OptionsTable ref="options" @check="addContent" />
      </el-col>
      <el-col :span="14">
        <ContentTable ref="content" />
      </el-col>
    </el-row>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <AddContent
      :visible.sync="addContentOpts.visible"
      :optionName="addContentOpts.optionName"
      :optionNameEn="addContentOpts.optionNameEn"
      @confirm="addContentConfirm"
    />
  </div>
</template>

<script>
import OptionsTable from '../options-table'
import ContentTable from '../content-table'
import AddContent from '../add-content'
export default {
  components: { OptionsTable, ContentTable, AddContent },
  mixins: [],
  props: {},
  data() {
    return {
      backDialogVisible: false,
      addContentOpts: { visible: false, optionName: '', optionNameEn: '' },
    }
  },
  methods: {
    addContent({ optionName, optionNameEn }) {
      this.addContentOpts = { visible: true, optionName, optionNameEn }
    },
    addContentConfirm(data) {
      this.$refs.content.addContent(data)
    },
    async save() {
      const result = await this.$refs.content.validate()
      if (!result) return (this.backDialogVisible = false)

      const data = this.$refs.content.getTableData()
      this.$emit('confirm', data)
      this.close()
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
